import React, { useEffect, useRef, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

import { PowerBIEmbed } from 'powerbi-client-react';

// import { Loading } from '@components';

// import '@style/modules/analysis/powerbi.scss';
import '../../styles/modules/analysis/powerbi.scss';

export const PowerBI = ({ data, wholeScreen, token, screenRatio = null }) => {
  // const [isLoading, toggleLoading] = useState(false);
  const [embedComfig, changeConfig] = useState({});
  const containerRef = useRef(null);

  useEffect(() => {
    changeConfig({});
    data &&
      setTimeout(
        () =>
          changeConfig({
            accessToken: token,
            ...data.embedUrl[0],
          }),
        100,
      );
  }, [data]);

  // useEffect(() => {
  //   debugger;
  //   if (Object.keys(embedComfig).length > 0 && wholeScreen) {
  //     setContainerPaddingLeft(containerRef);
  //   }
  // }, [embedComfig]);

  // const setContainerPaddingLeft = (containerDom) => {
  //   if (!containerDom) {
  //     return;
  //   }

  //   const contentHeight = document.body.clientHeight + 64;
  //   const contentWidth = document.body.clientWidth;
  //   const paddingLeft = contentWidth - (contentHeight * (1440 - 102)) / 789;
  //   containerDom.current.style.paddingLeft = `${paddingLeft}px`;
  //   containerDom.current.style.height = `100%`;
  // };

  // if (isLoading) {
  //   return (
  //     <div className="loading" ref={containerRef}>
  //       <Loading />
  //     </div>
  //   );
  // }

  return (
    <div ref={containerRef} style={{ width: '100%', height: '100%' }}>
      {isEmpty(embedComfig) ? null : (
        <PowerBIEmbed
          cssClassName={`powerbi-embed ${
            wholeScreen ? 'powerbi-embed-fix-height' : ''
          } ${
            screenRatio === '64:27'
              ? 'full-frame'
              : screenRatio === '16:9'
              ? 'standard-frame'
              : screenRatio === '32:7'
              ? 'platter-frame'
              : screenRatio === 'AUTO'
              ? 'auto-frame'
              : ''
          }`}
          embedConfig={{
            type: 'report',
            tokenType: 1,
            ...embedComfig,
            accessToken: token,
            layoutType: 3,
          }}
        />
      )}
    </div>
  );
};
